import React, { forwardRef } from 'react'
import { DetailStoreProvider } from '@vt/hooks'
import DetailModal from './detail-modal'

const Content = function (prop, ref) {
  return (
    <DetailStoreProvider>
      <DetailModal {...prop} ref={ref} />
    </DetailStoreProvider>
  )
}

export default forwardRef(Content)
